module.exports = __webpack_public_path__ + "img/folder.f74d10c3.svg";